import { render, staticRenderFns } from "./MapaComercio.vue?vue&type=template&id=3cc5114c&"
import script from "./MapaComercio.vue?vue&type=script&lang=js&"
export * from "./MapaComercio.vue?vue&type=script&lang=js&"
import style0 from "./MapaComercio.vue?vue&type=style&index=0&id=3cc5114c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports